if (!customElements.get('artist-pedals')) {
  class ArtistPedals extends HTMLElement {
    connectedCallback() {
      this.swiperInstance = null;
      this.autoplayResumeTimer = null;
      this.initSwiper();
    }

    // testimonials.js owns the Swiper instance (it inits any .testimonials-section).
    // We poll for it, then layer on pause-on-interaction / resume-after-8s.
    initSwiper() {
      var self = this;
      var checkInterval = setInterval(function () {
        var swiperEl = self.querySelector('.swiper');
        if (swiperEl && swiperEl.swiper) {
          self.swiperInstance = swiperEl.swiper;
          self.bindSwiperEvents();
          clearInterval(checkInterval);
        }
      }, 200);

      setTimeout(function () {
        clearInterval(checkInterval);
      }, 5000);
    }

    bindSwiperEvents() {
      if (!this.swiperInstance) return;
      var self = this;

      this.swiperInstance.on('sliderMove', function () {
        self.pauseAutoplay();
        self.scheduleAutoplayResume();
      });

      this.querySelectorAll('.swiper-button').forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          self.pauseAutoplay();
          self.scheduleAutoplayResume();
        });
      });
    }

    pauseAutoplay() {
      if (this.swiperInstance && this.swiperInstance.autoplay) {
        this.swiperInstance.autoplay.stop();
      }
      if (this.autoplayResumeTimer) {
        clearTimeout(this.autoplayResumeTimer);
        this.autoplayResumeTimer = null;
      }
    }

    scheduleAutoplayResume() {
      if (this.autoplayResumeTimer) {
        clearTimeout(this.autoplayResumeTimer);
      }
      var self = this;
      this.autoplayResumeTimer = setTimeout(function () {
        if (self.swiperInstance && self.swiperInstance.autoplay) {
          self.swiperInstance.autoplay.start();
        }
      }, 8000);
    }
  }

  customElements.define('artist-pedals', ArtistPedals);
}
